import axios from 'axios';
import { mavim } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

const headers = token => ({
    'Content-Type': 'application/json',
    'x-access-token': token
});

const commonParams = ({ from, to, companyId, typeId } = {}) => ({
    from,
    to,
    companyId: companyId || undefined,
    typeId: typeId || undefined
});

// NOTE: the shared makeQuery() helper pushes an empty string (instead of skipping) for any
// undefined/null/'' value, producing query strings like "status=x&&&&page=1". Strip those out first.
const compact = (params = {}) =>
    Object.keys(params).reduce((acc, key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
            acc[key] = params[key];
        }
        return acc;
    }, {});

export const getSummary = (filters, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/dashboard/summary?${makeQuery(compact(commonParams(filters)))}`,
        headers: headers(token)
    });

export const getKanban = (filters, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/dashboard/kanban?${makeQuery(compact({ ...commonParams(filters), cardsPerColumn: filters.cardsPerColumn || 3 }))}`,
        headers: headers(token)
    });

export const getSeries = (filters, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/dashboard/series?${makeQuery(compact({ ...commonParams(filters), bucket: filters.bucket || 'day' }))}`,
        headers: headers(token)
    });

export const getCompaniesRanking = (filters, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/dashboard/companies?${makeQuery(compact(commonParams(filters)))}`,
        headers: headers(token)
    });

export const getReasons = (filters, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/dashboard/reasons?${makeQuery(compact(commonParams(filters)))}`,
        headers: headers(token)
    });

export const getOperations = (filters, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/dashboard/tasks?${makeQuery(compact(filters))}`,
        headers: headers(token)
    });

export const getInventorySummary = (filters, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/inventory/summary/gps?${makeQuery(compact(filters))}`,
        headers: headers(token)
    });

const INVENTORY_LIST_PATHS = {
    gps: 'gps',
    simcards: 'simcards',
    devices: 'devices'
};

export const getInventoryList = (type, filters, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/inventory/${INVENTORY_LIST_PATHS[type] || 'gps'}?${makeQuery(compact(filters))}`,
        headers: headers(token)
    });
